import { render } from "./DownloadComponent.vue?vue&type=template&id=48e31161&scoped=true&bindings={\"marker\":\"props\"}"
import script from "./DownloadComponent.vue?vue&type=script&lang=js"
export * from "./DownloadComponent.vue?vue&type=script&lang=js"

import "./DownloadComponent.vue?vue&type=style&index=0&id=48e31161&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48e31161"

export default script